__turbopack_context__.v({
  "press": "BasicList-module-scss-module__xJ1ngW__press",
  "wrapper": "BasicList-module-scss-module__xJ1ngW__wrapper",
});
